import styled from 'styled-components';

import { theme } from 'assets/styles/theme';
import { H4 } from 'components/typography/Headers';

export const MyActivitySectionTitle = styled(H4)`
  ${theme.mq.phone} {
    font-size: 20px;
    line-height: 30px;
  }
`;
